import React from "react";
import "react-dropzone-uploader/dist/styles.css";
import Dropzone from "react-dropzone-uploader";
import { getDroppedOrSelectedFiles } from "html5-file-selector";

const Uploader = ({ onFileChange }) => {
  const getFilesFromEvent = (e) => {
    return new Promise((resolve) => {
      getDroppedOrSelectedFiles(e).then((chosenFiles) => {
        resolve(chosenFiles.map((f) => f.fileObject));
      });
    });
  };

  const SelectFileInput = ({ accept, onFiles, files, getFilesFromEvent }) => {
    const textMsg = files.length > 0 ? "Add more" : "Choose File";

    return (
      <>
        <label className="hf-btn hf-btn-berylline px-4 mr-3 mt-4 mb-2">
          {textMsg}
          <input
            style={{ display: "none" }}
            type="file"
            accept={accept}
            multiple
            onChange={(e) => {
              getFilesFromEvent(e).then((chosenFiles) => {
                onFiles(chosenFiles);
              });
            }}
          />
        </label>
      </>
    );
  };

  return (
    <>
      <Dropzone
        InputComponent={SelectFileInput}
        onChangeStatus={onFileChange}
        getFilesFromEvent={getFilesFromEvent}
        accept="image/*,audio/*,video/*, application/pdf/*"
        inputContent="Drop A File"
        styles={{
          preview: {
            display: "flex",
            justifyContent: "center",
            padding: "4px",
          },
        }}
      />
    </>
  );
};

export default Uploader;
